"use client";

import { ErrorLayout } from "@/components/layouts/error-layout";

import { ButtonGrouping } from "./button-grouping";

export function ReauthenticationRequired() {
  return (
    <ErrorLayout isLoading message="Redirecting you to login back in..." title="Reauthentication Required">
      <ButtonGrouping includeLogoutButton logoutButtonText="Or Click Here" />
    </ErrorLayout>
  );
}
